
export const authEndpoints = (builder) => ({
  login: builder.mutation({
    query: (credentials) => ({
      url: '/auth/login',
      method: 'POST',
      body: credentials,
    }),
  }),

  // Silent refresh
  refresh: builder.mutation({
    query: () => ({
      url: '/auth/refresh',
      method: 'POST',
    }),
  }),

  // Logout
  logout: builder.mutation({
    query: () => ({
      url: '/auth/logout',
      method: 'POST',
    }),
  }),

  // Register
  register: builder.mutation({
    query: (payload) => ({
      url: '/auth/register',
      method: 'POST',
      body: payload,
    }),
  }),

  // Reset password via one-time token (from welcome email)
  resetPassword: builder.mutation({
    query: (payload) => ({
      url: '/auth/reset-password',
      method: 'POST',
      body: payload,
    }),
  }),

  // Forgot password OTP flow
  forgotPassword: builder.mutation({
    query: (payload) => ({
      url: '/auth/forgot-password',
      method: 'POST',
      body: payload,
    }),
  }),

  verifyOTP: builder.mutation({
    query: (payload) => ({
      url: '/auth/verify-otp',
      method: 'POST',
      body: payload,
    }),
  }),

  resetPasswordOTP: builder.mutation({
    query: (payload) => ({
      url: '/auth/reset-password-otp',
      method: 'POST',
      body: payload,
    }),
  }),
});
